import {getField, updateField} from "vuex-map-fields"
import InstaplayAPI from "@/services/api/instaplays";
import {getRegisterState} from "@/store/States";

const state = getRegisterState()

const getters = {
    getRegisterField(state) {
        return getField(state.form);
    },
}

const actions = {
    async getTournaments({commit, rootState}) {
        commit('instaplayForm/itemLoading', null, {root: true})

        let response
        try {
            response = await InstaplayAPI.getTournaments(rootState.auth.user.token)
        } catch (e) {
            return commit('instaplayForm/itemError', null, {root: true})
        }

        if (response.Success) {
            for (let i = 0; i < response.tournament.length; i++) {
                commit('addTournament', response.tournament[i])
            }
            commit('instaplayForm/itemSuccess', null, {root: true})
        } else {
            commit('instaplayForm/itemError', null, {root: true})
        }
    },
}

const mutations = {
    resetState(state) {
        Object.assign(state, getRegisterState())
    },
    addTournament(state, tour) {
        state.form.tournamentItems.push({text: tour.name, value: tour.name})
    },
    updateRegisterField(state, field) {
        updateField(state.form, field);
    },
    setForm(state, form) {
        state.form.name = form.name
        state.form.image = form.image
        state.form.category = form.category
        state.form.prompt = form.prompt
        state.form.tournament = form.tournament
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
